import makeStyles from '@mui/styles/makeStyles';
import Box from "@mui/material/Box";
import theme from "src/theme/light";

const useStyles = makeStyles({
  list: {
    lineHeight: '1.5rem',
    color: '#00000099',
    textAlign: 'left',
    paddingLeft: '16px'
  },
})

export function PremissasText(){
  const classes = useStyles()

  return (
    <>
      <Box display="block" width="100%" textAlign={"left"} component="span" fontSize={18} fontWeight={500} color={theme.palette.primary.main}>Premissas de Cálculo</Box>
      <ul className={classes.list}>
        <li><strong>Valores de HSP</strong> (Horas de Sol Pico) com base no banco de dados do INPE (2006);</li>
        <li>O dimensionamento do sistema considera que os <strong>módulos estarão com inclinação ideal e voltados para a direção norte</strong>, sem sombreamento e módulos 0% de sujidade.</li>
        <li>Geração mensal = HSP Médio (horizontal) x Potência do Gerador x 30 x Fator de Perdas.</li>
        <ul>
          <li>30 - padrão de dias de um mês.</li>
          <li>Fator de perdas = 1 - Fator de perdas (Fator inserido no projeto)</li>
        </ul>
      </ul>
    </>
  )
}